/**
 * Element - input
 */

const handler_normalInput = (element: Element):void => {

}

const handler_checkbox = (element: Element):void => {
  let autoTriggerBlocker = false
  const subElement = element.querySelector('.js-input-checkbox')
  const inputElement = element.querySelector('input[type=checkbox]') as HTMLInputElement

  const checkboxStateChecker = (subElement: Element) => {
    // Block from self-triggering
    if (autoTriggerBlocker) { return }
    setTimeout(() => {
      autoTriggerBlocker = false
    }, 100)
    autoTriggerBlocker = true

    // Remove class if exising, "return" added to prevent self-cycling and
    if (subElement.classList.contains('-checked')) {
      subElement.classList.remove('-checked')
      return
    } // Add class if missing OR override is on
    if (!subElement.classList.contains('-checked')) {
      subElement.classList.add('-checked')
    }
  }

  // If input exists, set default state (checkbox gets buggy with saving sometimes for contact form plugins)
  if (subElement && inputElement && inputElement.checked) {
    subElement.classList.add('-checked')
  }
  if (subElement && inputElement && !inputElement.checked) {
    subElement.classList.remove('-checked')
  }

  // Trigger on fancy visual checkbox click
  if (subElement) {
    subElement.addEventListener('click', () => checkboxStateChecker(subElement))
  }

  // Trigger on change if normal, hidden input element if present
  if (inputElement && subElement) {
    inputElement.addEventListener('change', () => checkboxStateChecker(subElement))
  }
}

export const input = ():void => {
  // Run the script for each individual element found on the page
  const elementSelector = document.querySelectorAll('.js-input') as unknown as Element[]
  elementSelector.forEach((element:Element) => {
    // Normal input
    if (element.classList.contains('input--normal')) {
      handler_normalInput(element)
    }

    // Checkbox
    if (element.classList.contains('input--checkbox')) {
      handler_checkbox(element)
    }
  })
}
